import LangJs from 'lang.js';
import { useAuthStore } from '@/stores/auth.ts';
import { httpService } from '@/core/index';
import { changeLocaleUrl } from '@/api/auth';

export default class Lang {
  constructor() {
    this._lang = null;
    this._country = null;
    this._context = require.context('../../resources/translations', false, /\.json$/u, 'lazy');
    this._locale = null;
  }

  trans(key, replacements) {
    if (useAuthStore().previewModes?.translations) {
      return key;
    }

    return this._lang.trans(key, replacements);
  }

  choice(key, plural, replacements) {
    if (useAuthStore().previewModes?.translations) {
      return key;
    }

    return this._lang.choice(key, plural, replacements);
  }

  async changeLocale(locale) {
    this._lang.setMessages(await this._loadLocale(locale));

    this._lang.locale = locale;

    await httpService.get(changeLocaleUrl(locale));
    useAuthStore().setLocale(locale); // just to trigger rerender on UI
  }

  async load(locale, country = null) {
    this._locale = locale;
    this._country = country;
    useAuthStore().setLocale(locale);

    this._lang = new LangJs({
      locale: locale,
      messages: await this._loadLocale(locale),
      fallback: 'lt',
    });
  }

  async loadFromResponse(data, locale, country = null) {
    this._locale = locale;
    this._country = country;
    useAuthStore().setLocale(locale);

    this._lang = new LangJs({
      locale: locale,
      messages: data,
      fallback: 'lt',
    });
  }

  async _loadLocale(locale) {
    return this._context(`./${locale}.json`);
  }

  getLocale() {
    return this._locale;
  }

  getCountry() {
    return this._country;
  }

  setLocale(locale) {
    this._locale = locale;
  }

  setCountry(country) {
    this._country = country;
  }
}
